export const maintenanceRepair = {
  addMaintenance: "New Maintenance",
  addMaintenanceTemplate: "New Maintenance Template",
  addRepair: "New Repair",
  applicant: "Applicant",
  applyDate: "Application Time",
  approval: "Approval",
  approvalDate: "Approval Time",
  approvalNote: "Approver Comments",
  approvalRecord: "Approval Record",
  approvalResult: "Approval Result",
  approvalResultApproval: "Approve",
  approvalResultModify: "Supplement Required",
  approvalResultReject: "Reject",
  approvalUserName: "Approver",
  cancel: "Withdrew",
  cancelSuccessfully: "Withdrew succesfully",
  closeDate: "Finished Time",
  deleteMaintenanceGroupTip:
    'The maintenance group "{0}" will be deleted. Are you sure you want to proceed?',
  deleteMaintenanceItemTip:
    'The maintenance item "{0}" will be deleted. Are you sure you want to proceed?',
  done: "Close",
  editMaintenance: "Edit Maintenance",
  editMaintenanceTemplate: "Edit Maintenance Template",
  editRepair: "Edit Repair",
  failedToDeleteGroupNotEmpty: "Failed to delete. The group is not empty.",
  failedToDeleteItemUsed:
    "Failed to delete. The item is used by another template.",
  failedToDeleteTemplateUsed: "Failed to delete. The template ({0}) is in use.",
  maintainer: "Maintainer",
  maintenanceApproval: "Maintenance Approval",
  maintenanceCancelTips:
    'The maintenance application "{0}" will be withdrew. Are you sure you want to proceed?',
  maintenanceDetail: "Maintenance Details",
  maintenanceHasApproved: "The maintenance application has been approved.",
  maintenanceHasCanceled:
    'The maintenance application "{0}" has been withdrew.',
  maintenanceHasModified:
    "The maintenance application is in the process of being approved and cannot be modified.",
  maintenanceItem: "Maintenance Item",
  maintenanceNumber: "Maintenance ID",
  maintenanceRecord: "Maintenance Record",
  maintenanceReport: "Maintenance Report",
  maintenanceTemplate: "Maintenance Template",
  maintenanceTemplateDeleteTips:
    'Maintenance Template "{0}" will be deleted. Are you sure you want to proceed?',
  maintenanceTemplateName: "Maintenance Template Name",
  maxSizeImageTips: "You can upload {0} pictures at most.",
  modelsNumber: "Vehicle Models",
  needApproval: "Approval required",
  nextMaintenanceDate: "Next Maintenance Date",
  operation: "Operation",
  pleaseInputMaintenanceTemplateName:
    "Please input a maintenance template name",
  pleaseInputRepairName: "Please input a maintenance item",
  pleaseSelectMaintenanceTemplate: "Please select a maintenance template",
  pleaseSelectVehicle: "Please select a vehicle",
  qrCodeTips:
    "Please scan the code to open the CWorkX WeChat applet and fill in.",
  repairApproval: "Repair Approval",
  repairCancelTips:
    'The repair application "{0}" will be withdrew. Are you sure you want to proceed?',
  repairContent: "Repair Item",
  repairDescription: "Issue Description",
  repairDetail: "Repair Details",
  repairer: "Maintainer",
  repairHasApproved: "The repair application has been approved.",
  repairHasCanceled: 'The repair application "{0}" has been withdrew.',
  repairHasModified:
    "The repair application is in the process of being approved and cannot be modified.",
  repairNumber: "Repair ID",
  repairRecord: "Repair Record",
  repairReport: "Repair Report",
  status: "Status",
  statusApplying: "Approval in progress",
  statusApproval: "Under maintenance",
  statusCancel: "Withdrew",
  statusDone: "Finished",
  statusModify: "Supplement Required",
  statusReject: "Rejected",
  templateItem: "Itemed",
  tipsMaintenanceItemsEmpty: "Please select one maintenance item at least.",
  vehicleIsInMaintenance: "The vehicle is under maintenance now.",
  vehicleModel: "Vehicle Model",
  vehiclesIsInMaintenance: "The vehicles {0} are under maintenance now.",
  batchApproval: "Batch Approval",
  batchMaintenance: "Batch Maintenance",
};
